import { SafeImg } from "./SafeImg";
import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, Users, ArrowRight, Crown } from "lucide-react";
import { formatPrice } from "../mock/mockData";
import { citySlug } from "../lib/seo";
import { useCategories } from "../context/CategoriesContext";
import { isPerPerson } from "../lib/price";

const VenueCard = ({ venue, index = 0 }) => {
  const { categories } = useCategories();
  const isMekan = (categories.find((c) => c.slug === venue.category) || {}).group === "mekan";
  const isNew = (() => {
    if (!venue.createdAt) return false;
    const t = new Date(venue.createdAt).getTime();
    if (Number.isNaN(t)) return false;
    return Date.now() - t <= 7 * 24 * 60 * 60 * 1000;
  })();
  const hl = !!venue.highlighted;
  return (
    <Link
      to={venue.category && venue.city ? `/${venue.category}/${citySlug(venue.city)}/${venue.slug}` : `/mekan/${venue.slug}`}
      data-testid={hl ? "highlighted-venue-card" : undefined}
      className={`card-hover group block bg-white rounded-2xl overflow-hidden animate-fade-up ${hl ? "border-2 border-[#C6A15B] shadow-[0_10px_34px_rgba(198,161,91,0.38)]" : "border border-[#F0DDE0]"}`}
      style={{ animationDelay: `${(index % 4) * 0.08}s` }}
    >
      <div className="img-zoom relative h-44">
        <SafeImg
          src={venue.image}
          alt={venue.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 to-transparent opacity-70" />
        <div className="absolute top-3 left-3 flex flex-col items-start gap-1.5">
          {hl && (
            <span data-testid="highlighted-badge" className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-gradient-to-r from-[#C6A15B] to-[#a9843f] text-white text-xs font-bold shadow ring-1 ring-white/40">
              <Crown className="w-3.5 h-3.5" fill="currentColor" /> Vurgulu İlan
            </span>
          )}
          {venue.featured && (
            <span className="px-3 py-1 rounded-full bg-[#C6A15B] text-white text-xs font-medium shadow">
              Öne Çıkan
            </span>
          )}
          {isNew && (
            <span data-testid="new-badge" className="px-3 py-1 rounded-full bg-[#2E8B57] text-white text-xs font-medium shadow">
              Yeni
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/95 text-[#2A2224] text-xs font-semibold shadow">
          <Star className="w-3.5 h-3.5 text-[#C6A15B]" fill="#C6A15B" />
          {venue.rating}
        </div>
        <div className="absolute bottom-3 left-3 flex items-center gap-1 text-white text-xs">
          <MapPin className="w-3.5 h-3.5" />
          {venue.district}, {venue.city}
        </div>
      </div>

      <div className={`p-5 ${hl ? "bg-gradient-to-b from-[#FDF8EE] to-white" : ""}`}>
        <h3 className={`font-display text-lg group-hover:text-[#9E2A3B] transition-colors line-clamp-1 ${hl ? "font-extrabold text-[#2A2224]" : "font-semibold text-[#2A2224]"}`}>
          {venue.name}
        </h3>
        {isMekan && (
          <div className="flex items-center gap-2 mt-2 text-sm text-[#7C6E70]">
            <Users className="w-4 h-4 text-[#C15B6B]" />
            {venue.capacity}
          </div>
        )}

        <div className="flex flex-wrap gap-1.5 mt-3">
          {venue.features.slice(0, 3).map((f) => (
            <span key={f} className="px-2.5 py-1 rounded-full bg-[#F6E4E6] text-[#9E2A3B] text-[11px]">
              {f}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between mt-4 pt-4 border-t border-[#F0DDE0]">
          <div>
            {venue.priceFrom > 0 ? (
              <>
                <span className="text-[11px] text-[#7C6E70] block">Başlangıç</span>
                <span className="font-display text-lg font-bold text-[#9E2A3B]">{formatPrice(venue.priceFrom)}{isPerPerson(venue.priceFrom, isMekan ? "mekan" : "", venue.priceType) && <span className="text-xs font-sans font-medium text-[#7C6E70]" data-testid="price-per-person"> / kişi başı</span>}</span>
              </>
            ) : (
              <span className="text-sm font-medium text-[#7C6E70]">Fiyat için teklif alın</span>
            )}
          </div>
          <span className="flex items-center gap-1 text-sm font-medium text-[#C15B6B] group-hover:gap-2 transition-all">
            İncele <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default VenueCard;
